import * as React from 'react';
import { Elements } from 'react-stripe-elements';
import InjectedPaymentDetailsForm from './InjectedPaymentDetailsForm';

interface Props {
	details: any;
	actions: any;
	hidden?: boolean;
	onStripeElementChange?: (element: any, name: any) => void;
}
const PaymentDetailsForm: React.StatelessComponent<Props> = props => {
	return (
		<div hidden={props.hidden}>
			<Elements
				fonts={[
					{
						cssSrc: 'https://fonts.googleapis.com/css?family=Nunito+Sans:400'
					}
				]}
			>
				<InjectedPaymentDetailsForm
					details={props.details}
					actions={props.actions}
					onStripeElementChange={props.onStripeElementChange}
				/>
			</Elements>
		</div>
	);
};
export default PaymentDetailsForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/PaymentDetailsForm.tsx